import * as app from './app/actions'
import * as me from './me/actions'


export default {
  app,
  me,
}
